<template>
<div class="pageMessage">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
        <div class="orderlist">
            <div class="item" v-for="order in orderList" :key="order.id" @click="goOrderDetail(order)">
                <div class="item_top" >您的订单{{order.order_tips}}</div>
                <div class="item_info">
                    <van-image class="item_tu" fit="contain" :show-error="false" :show-loading="false" :src="order.good_thumb ? order.good_thumb : $publicData.intangibleDefault" />
                    <div class="order">
                        <div class="order_info">订单{{'['+ order.order_num +']' + order.order_tips}}</div>
						<!-- 商品订单 -->
                        <div class="actions" v-if="(order.order_type == 1 && order.type == 2) || (order.order_type == 1 && order.type == 3)">
                            <div class="action" v-if="order.type == 2" @click="goOrderDetail(order)" >查看物流</div>
                            <div class="action" v-if="order.type == 3" @click="goOrderDetail(order)">点击评论</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </van-list>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            token: this.$store.getters.token,
            pages: {
                page: 1,
                size: 10
            },
            loading: false,
            finished: false,
            orderList: null, // 订单信息
            token: null,
			sorce: this.$route.query.sorce, // 0商城 1云支付
			// orderType: 1 // 订单类型 1商品订单 2定制订单
        };
    },
    created: function () {
            //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'naviTitle': '订单消息',
                    }
                }
                this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

                })
                var memberParams = {
                    data: {
                    },
                }
                //加载用户信息
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    console.log(data)
                    if (data.code == 200) {
                        this.token = data.result.token
                        this.getData()
                    }
                })
                //注册方法，客户端重新进入页面刷新数据
                this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data)
                })
            } else {
                // 获取列表
                this.token = this.$store.getters.token
                this.getData();
            }
    },
    methods: {
        // 获取列表
        getData() {
            var that = this
            var params = {
                token: this.token,
                page: this.pages.page,
				size: this.pages.size
            }
            this.$api.xiaoxi.orderMsg(params).then(res => {
                if (res.code == 200) {
                    var list = []
                    list = res.result
                    if (this.pages.page == 1) {
                        that.orderList = []
                    }
                    if (list.length != 0) {
                        for (var i in list) {
							// 普通商品订单
							if(list[i].order_type == 1){
								if (list[i].type == -2) {
									list[i].order_tips = '已关闭'
								} else if (list[i].type == -1) {
									list[i].order_tips = '已取消'
								} else if (list[i].type == 1) {
									list[i].order_tips = '支付成功'
								} else if (list[i].type == 2) {
									list[i].order_tips = '已发货'
								} else if (list[i].type == 3) {
									list[i].order_tips = '已收货'
								}
							}
							// 定制商品
							if(list[i].order_type == 2){
								if (list[i].type == -2) {
									list[i].order_tips = '已关闭'
								} else if (list[i].type == -1) {
									list[i].order_tips = '已取消'
								} else if (list[i].type == 1) {
									list[i].order_tips = '尾款支付成功'
								} else if (list[i].type == 2) {
									list[i].order_tips = '已完成'
								} else if (list[i].type == 3) {
									list[i].order_tips = '已收货'
								} else if(list[i].type == 4){
									list[i].order_tips = '定金支付成功'
								}
							}
                            that.orderList.push(list[i])
                        }
                    } else {
                        this.finished = true
                    }
                } else {
                    this.finished = true
                }
                this.pages.page++
                this.loading = false
            })
		},
		// 订单详情
        goOrderDetail(order) {
			console.log(order)
			// order_type 1 商品订单 、  2 定制订单
			if(order.order_type == 1){
				if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
					var p = "?orderId=" + order.order_id + '&sorce=' + this.sorce
					var params = {
						'data': {
							'url': this.$publicData.clientUrl + '/order/detail' + p
						}
					}
					this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

					})
				} else {
					this.$router.push({
						path: '/order/detail',
						query: {
							orderId: order.order_id,
							sorce: this.sorce
						}
					})
				}
			}else{
				// 定制订单 
				if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
					var params = {
						'data': {
							'url': this.$publicData.clientUrl + '/order/dingzhi/detail?id=' + order.order_id
						}
					}
					this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

					})
				} else {
					this.$router.push({
						path: '/order/dingzhi/detail',
						query: {
								id: order.order_id
							}
					})
				}
			}
            
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
